module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.panelClass
  }, [_c('div', {
    staticClass: "panel__frame"
  }, [(this.tabs) ? _c('ul', {
    staticClass: "panel__tab-list"
  }, _vm._l((this.$data.tablists[this.tabs]), function(item, index) {
    return _c('li', {
      staticClass: "panel__tab-item"
    }, [_c('button', {
      class: _vm.setCurrentTabClass(item.name),
      on: {
        "click": function($event) {
          _vm.setCurrentTab(item.name)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "icon": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "panel__tab-tip"
    }, [_vm._v(_vm._s(item.title))])], 1)])
  })) : _vm._e(), _vm._v(" "), (this.save) ? _c('div', {
    staticClass: "panel__control"
  }, [_c('div', {
    staticClass: "panel__buttons"
  }, [_c('button', {
    staticClass: "button modal-default-button",
    on: {
      "click": _vm.panelSave
    }
  }, [_vm._v(_vm._s(_vm._translate('panel.save')))]), _vm._v(" "), (this.context === 'client') ? _c('button', {
    staticClass: "button modal-default-button",
    on: {
      "click": _vm.showDisclaimers
    }
  }, [_vm._v(_vm._s(_vm._translate('panel.disclaimers')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.context === 'load') ? _c('div', {
    staticClass: "panel__block panel__block--client-picker"
  }, [_c('h2', [_vm._v(_vm._s(_vm._translate('panel.selectClient')))]), _vm._v(" "), _c('ClientPicker', {
    attrs: {
      "id": "spouse-picker",
      "context": "client"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.context === 'client') ? _c('div', {
    staticClass: "panel__block"
  }, [(_vm.isCurrentTab('details')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.clientDetails')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "active",
      "label": _vm._translate('panel.clientDeactivate'),
      "field": "details.deactivate",
      "value": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "firstName",
      "label": _vm._translate('panel.firstName'),
      "field": "details.firstName",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lastName",
      "label": _vm._translate('panel.lastName'),
      "field": "details.lastName",
      "type": "text"
    }
  }), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "id": "dateOfBirth",
      "title": _vm._translate('panel.useRetirementDate'),
      "field": "details.dateOfBirth",
      "showage": "true"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "gender",
      "field": "details.gender",
      "label": _vm._translate('panel.gender'),
      "proto": "gender"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "maritalStatus",
      "field": "details.maritalStatus",
      "label": _vm._translate('panel.maritalStatus'),
      "proto": "maritalStatus"
    }
  }), _vm._v(" "), _c('Spouse', {
    attrs: {
      "title": _vm._translate('panel.spouse'),
      "field": "details.spouse"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "source",
      "label": _vm._translate('panel.source'),
      "field": "details.source",
      "type": "text"
    }
  }), _vm._v(" "), _c('Addr', {
    attrs: {
      "title": _vm._translate('panel.address'),
      "field": "details.address"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "phoneHome",
      "label": _vm._translate('panel.homePhone'),
      "field": "details.phoneHome",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "phoneWork",
      "label": _vm._translate('panel.workPhone'),
      "field": "details.phoneWork",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "phoneCell",
      "label": _vm._translate('panel.cellPhone'),
      "field": "details.phoneCell",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "fax",
      "label": _vm._translate('panel.faxNumber'),
      "field": "details.fax",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "email",
      "label": _vm._translate('panel.email'),
      "field": "details.email",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "occupation",
      "label": _vm._translate('panel.occupation'),
      "field": "details.occupation",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "employer",
      "label": _vm._translate('panel.employer'),
      "field": "details.employer",
      "type": "text"
    }
  }), _vm._v(" "), _c('Addr', {
    attrs: {
      "title": _vm._translate('panel.employerAddress'),
      "field": "details.employerAddress"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.clientBeneficiary')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "firstName",
      "label": _vm._translate('panel.firstName'),
      "field": "details.beneficiaryFirstName",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lastName",
      "label": _vm._translate('panel.lastName'),
      "field": "details.beneficiaryLastName",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lastName",
      "label": _vm._translate('panel.age'),
      "field": "details.beneficiaryAge",
      "type": "age"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.clientExecutor')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "firstName",
      "label": _vm._translate('panel.firstName'),
      "field": "details.executorFirstName",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lastName",
      "label": _vm._translate('panel.lastName'),
      "field": "details.executorLastName",
      "type": "text"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lastName",
      "label": _vm._translate('panel.age'),
      "field": "details.executorAge",
      "type": "age"
    }
  })], 1) : (_vm.isCurrentTab('income')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.incomeDetails')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "presentIncome",
      "label": _vm._translate('panel.presentIncome'),
      "field": "income.presentIncome",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "otherSources",
      "label": _vm._translate('panel.incomeOtherSources'),
      "field": "income.otherSources",
      "type": "currency"
    }
  })], 1) : (_vm.isCurrentTab('government')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.pension')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "pensionAge",
      "label": _vm._translate('panel.pensionAge'),
      "field": "retirement.pensionAge",
      "type": "age"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "pensionIndex",
      "label": _vm._translate('panel.indexPension'),
      "field": "retirement.pensionIndex",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "pensionBenefit",
      "label": _vm._translate('panel.pensionBenefit'),
      "field": "retirement.pensionBenefit",
      "type": "currency"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "cppIntegrate",
      "label": _vm._translate('panel.cppIntegrate'),
      "field": "retirement.cppIntegrate",
      "value": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "hasBridgeBenefit",
      "label": _vm._translate('panel.hasBridgeBenefit'),
      "field": "retirement.hasBridgeBenefit",
      "value": "true"
    }
  }), _vm._v(" "), (_vm.showFromCheckbox('retirement.hasBridgeBenefit')) ? _c('TextInput', {
    attrs: {
      "id": "bridgeValue",
      "label": _vm._translate('panel.bridgeValue'),
      "field": "retirement.bridgeValue",
      "type": "currency"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFromCheckbox('retirement.hasBridgeBenefit')) ? _c('TextInput', {
    attrs: {
      "id": "bridgeStart",
      "label": _vm._translate('panel.bridgeStart'),
      "field": "retirement.bridgeStart",
      "type": "age"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFromCheckbox('retirement.hasBridgeBenefit')) ? _c('TextInput', {
    attrs: {
      "id": "bridgeEnd",
      "label": _vm._translate('panel.bridgeEnd'),
      "field": "retirement.bridgeEnd",
      "type": "age"
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.cppTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "cppAtAge",
      "label": _vm._translate('panel.cppAtAge'),
      "field": "retirement.cppAtAge",
      "type": "age"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "cppIndex",
      "label": _vm._translate('panel.cppIndex'),
      "field": "retirement.cppIndex",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "cppCustomValue",
      "label": _vm._translate('panel.cppCustomValue'),
      "field": "retirement.cppCustomValue",
      "value": "true"
    }
  }), _vm._v(" "), (_vm.showFromCheckbox('retirement.cppCustomValue')) ? _c('TextInput', {
    attrs: {
      "id": "cppValue",
      "label": _vm._translate('panel.cppValue'),
      "field": "retirement.cppValue",
      "type": "currency"
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.oasTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "oasAtAge",
      "label": _vm._translate('panel.oasAtAge'),
      "field": "retirement.oasAtAge",
      "type": "age"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "oasIndex",
      "label": _vm._translate('panel.oasIndex'),
      "field": "retirement.oasIndex",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "oasCustomValue",
      "label": _vm._translate('panel.oasCustomValue'),
      "field": "retirement.oasCustomValue",
      "value": "true"
    }
  }), _vm._v(" "), (_vm.showFromCheckbox('retirement.oasCustomValue')) ? _c('TextInput', {
    attrs: {
      "id": "oasValue",
      "label": _vm._translate('panel.oasValue'),
      "field": "retirement.oasValue",
      "type": "currency"
    }
  }) : _vm._e()], 1) : (_vm.isCurrentTab('retirement')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.generalTitle')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementDate",
      "label": _vm._translate('panel.useRetirementDate'),
      "field": "retirement.useRetirementDate",
      "value": "true"
    }
  }), _vm._v(" "), (!_vm.showFromCheckbox('retirement.useRetirementDate')) ? _c('TextInput', {
    attrs: {
      "id": "retirementAge",
      "label": _vm._translate('panel.retireAge'),
      "field": "retirement.retirementAge",
      "type": "age"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFromCheckbox('retirement.useRetirementDate')) ? _c('DatePicker', {
    attrs: {
      "id": "retirementDate",
      "title": _vm._translate('panel.retirementDate'),
      "field": "retirement.retirementDate",
      "showage": "true",
      "yearOrder": "asc"
    }
  }) : _vm._e(), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "requiredAtRetirement",
      "label": _vm._translate('panel.perentageIncome'),
      "field": "retirement.requiredAtRetirement",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "passiveRetirementAge",
      "label": _vm._translate('panel.passiveRetireAge'),
      "field": "retirement.passiveRetirementAge",
      "type": "age"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "passiveIncomeRequired",
      "label": _vm._translate('panel.percentagePassiveIncome'),
      "field": "retirement.passiveIncomeRequired",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "lifeExpectancy",
      "label": _vm._translate('panel.lifeExpectancy'),
      "field": "retirement.lifeExpectancy",
      "type": "age"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "estateValue",
      "label": _vm._translate('panel.estateTarget'),
      "field": "retirement.estateValue",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "inflationRate",
      "label": _vm._translate('panel.inflationRate'),
      "field": "retirement.inflationRate",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.retirementPlanTitle')))]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "startPlan",
      "field": "retirement.startPlan",
      "label": _vm._translate('panel.startPlanIn'),
      "proto": "yearsRange"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "withdrawalOrder",
      "field": "retirement.withdrawalOrder",
      "label": _vm._translate('panel.withdrawalOrder'),
      "proto": "withdrawalOrder"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "autofillShortfall",
      "field": "retirement.autofillShortfall",
      "label": _vm._translate('panel.automaticShortfalls'),
      "proto": "trueFalse"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "fromSavings",
      "label": _vm._translate('panel.percentagefromSavings'),
      "field": "retirement.fromSavings",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "fromLockedin",
      "label": _vm._translate('panel.percentagefromLockedin'),
      "field": "retirement.fromLockedin",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "fromTfsa",
      "label": _vm._translate('panel.percentagefromTFSA'),
      "field": "retirement.fromTfsa",
      "type": "percentage"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "fromRegistered",
      "label": _vm._translate('panel.percentagefromRegistered'),
      "field": "calc.fromRegistered",
      "type": "percentage",
      "disabled": "true"
    }
  })], 1) : (_vm.isCurrentTab('savings')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.nonregisteredTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'savings.open.chequing',
        'savings.open.savings',
        'savings.open.mutualFunds',
        'savings.open.stocks',
        'savings.open.other'
      ], 'balance'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.chequingAccounts'),
      "field": "savings.open.chequing",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.savingsAccounts'),
      "field": "savings.open.savings",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.stocks'),
      "field": "savings.open.stocks",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.mutualFunds'),
      "field": "savings.open.mutualFunds",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.other'),
      "field": "savings.open.other",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.tfsaTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'savings.open.tfsa' ], 'balance'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.tfsa'),
      "field": "savings.open.tfsa",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.registeredTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'savings.registered.mutualFunds',
        'savings.registered.other',
        'savings.registered.rrif' ], 'balance'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savings-wrap"
  }, [_c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.mutualFunds'),
      "field": "savings.registered.mutualFunds",
      "totalby": "balance",
      "proto": "account"
    }
  })], 1), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.other'),
      "field": "savings.registered.other",
      "totalby": "balance",
      "proto": "account"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savings-wrap"
  }, [_c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.rrif'),
      "field": "savings.registered.rrif",
      "totalby": "balance",
      "proto": "retirementAccount"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.dpspTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'savings.registered.dpspEsopGrsp' ], 'balance'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savings-wrap"
  }, [_c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.dpsp'),
      "field": "savings.registered.dpspEsopGrsp",
      "totalby": "balance",
      "proto": "retirementAccount"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.otherTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'savings.lockedin.employerPension',
        'savings.lockedin.lockedRrsp' ], 'balance'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savings-wrap"
  }, [_c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.employerPensionPlan'),
      "field": "savings.lockedin.employerPension",
      "totalby": "balance",
      "proto": "retirementAccount"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "minmax_lockedin_pension",
      "label": _vm._translate('panel.useMinMax'),
      "field": "savings.minmax_lockedin_pension",
      "value": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savings-wrap"
  }, [_c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.rrsp'),
      "field": "savings.lockedin.lockedRrsp",
      "totalby": "balance",
      "proto": "retirementAccount"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "minmax_lockedin_lockedRrsp",
      "label": _vm._translate('panel.useMinMax'),
      "field": "savings.minmax_lockedin_lockedRrsp",
      "value": "true"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.annualValuesTitle')))]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.annualValues'),
      "field": "savings.periodicValues.values",
      "totalby": "balance",
      "display": "last",
      "proto": "periodicValues",
      "autofill": "autofillValueTotals"
    }
  }), _vm._v(" "), (_vm.useAdjustments) ? _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.adjustedContributions'),
      "field": "retirement.adjustedContributions",
      "totalby": "none",
      "display": "last",
      "proto": "contributions"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.useAdjustments) ? _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.adjustedWithdrawals'),
      "field": "retirement.adjustedWithdrawals",
      "totalby": "none",
      "display": "last",
      "proto": "withdrawals"
    }
  }) : _vm._e()], 1) : (_vm.isCurrentTab('assets')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.realEstateTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'assets.realEstate.home',
        'assets.realEstate.other' ], 'value'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.personalHomes'),
      "field": "assets.realEstate.home",
      "totalby": "value",
      "proto": "realEstate"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.otherRealEstate'),
      "field": "assets.realEstate.other",
      "totalby": "value",
      "proto": "realEstate"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.businessInterestsTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'assets.other.businessInterests' ], 'value'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.businessInterests'),
      "field": "assets.other.businessInterests",
      "totalby": "value",
      "proto": "property"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.otherAssetsTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'assets.other.taxDefered',
        'assets.other.other' ], 'value'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.taxDeferredAssets'),
      "field": "assets.other.taxDefered",
      "totalby": "value",
      "proto": "property"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.otherAssets'),
      "field": "assets.other.other",
      "totalby": "value",
      "proto": "property"
    }
  })], 1) : (_vm.isCurrentTab('debt')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.shortTermDebtTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'debt.shortTerm.creditCards',
        'debt.shortTerm.carLoans',
        'debt.shortTerm.lineOfCredit',
        'debt.shortTerm.other' ], 'balance'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.creditCards'),
      "field": "debt.shortTerm.creditCards",
      "totalby": "balance",
      "proto": "debtAccount"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.carLoans'),
      "field": "debt.shortTerm.carLoans",
      "totalby": "balance",
      "proto": "debtAccount"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.lineOfCredit'),
      "field": "debt.shortTerm.lineOfCredit",
      "totalby": "balance",
      "proto": "debtAccount"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.otherDebts'),
      "field": "debt.shortTerm.other",
      "totalby": "balance",
      "proto": "debtAccount"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.longTermDebtTitle')) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sumRepeaters([
        'debt.longTerm.mortgageHome',
        'debt.longTerm.mortgageOther',
        'debt.longTerm.investmentLoans' ], 'balance'))
    }
  })]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.homeMortgage'),
      "field": "debt.longTerm.mortgageHome",
      "totalby": "balance",
      "proto": "mortgage"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.otherMortgages'),
      "field": "debt.longTerm.mortgageOther",
      "totalby": "balance",
      "proto": "mortgage"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.investmentLoans'),
      "field": "debt.longTerm.investmentLoans",
      "totalby": "balance",
      "proto": "account"
    }
  })], 1) : (_vm.isCurrentTab('insurance')) ? _c('div', {
    staticClass: "panel__tab"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.lifeInsuranceTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "group",
      "label": _vm._translate('panel.insuranceGroup'),
      "tmp": "Group",
      "field": "insurance.group",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "life",
      "label": _vm._translate('panel.lifeInsurance'),
      "tmp": "Life Insurance",
      "field": "insurance.life",
      "type": "currency"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.lifeInsuranceNeedsTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "employerLife",
      "label": _vm._translate('panel.employerLifeInsurance'),
      "tmp": "Employer Life Insurance",
      "field": "insurance.employerLife",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "mortgage",
      "label": _vm._translate('panel.mortgageInsurance'),
      "tmp": "Mortgage Insurance",
      "field": "insurance.mortgage",
      "type": "currency"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.cashRequiredTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "funeralExpenses",
      "label": _vm._translate('panel.funeralExpenses'),
      "tmp": "Funeral Expenses",
      "field": "retirement.funeralExpenses",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "legalFees",
      "label": _vm._translate('panel.estateFees'),
      "tmp": "Probate, Executor, Legal, Accounting Fees",
      "field": "retirement.legalFees",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "shortTermLiving",
      "label": _vm._translate('panel.shortTermLivingExpenses'),
      "tmp": "Short Term Living Expenses",
      "field": "retirement.shortTermLiving",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "education",
      "label": _vm._translate('panel.postSecondaryExpenses'),
      "tmp": "Post Secondary Education for Children",
      "field": "retirement.education",
      "type": "currency"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.insuranceCashValueTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "insuranceCashValue",
      "label": _vm._translate('panel.lifeInsuranceCashValue'),
      "tmp": "Life Insurance Cash Value",
      "field": "insurance.insuranceCashValue",
      "type": "currency"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.capitalGainsTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "adjustedRealEstate",
      "label": _vm._translate('panel.adjustedCostRealEstate'),
      "tmp": "Adjusted Cost Basis of Real Estate",
      "field": "insurance.adjustedRealEstate",
      "type": "currency"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "taxableCapitalGains",
      "label": _vm._translate('panel.taxableCapitalGains'),
      "tmp": "Taxable Portion of Capital Gains",
      "field": "insurance.taxableCapitalGains",
      "type": "percentage"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.context === 'tools') ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.toolsTitle')))]), _vm._v(" "), _c('Tool', {
    attrs: {
      "context": "savingsFuture",
      "title": _vm._translate('panel.toolSavingsFuture'),
      "tmp": "Savings Required for Future",
      "icon": "pig"
    }
  }), _vm._v(" "), _c('Tool', {
    attrs: {
      "context": "investmentFuture",
      "title": _vm._translate('panel.toolFutureValue'),
      "tmp": "Future Value of an Investment",
      "icon": "future-value"
    }
  }), _vm._v(" "), _c('Tool', {
    attrs: {
      "context": "regularWithdrawals",
      "title": _vm._translate('panel.toolRegularWithdrawals'),
      "tmp": "Regular Withdrawals from an Investment",
      "icon": "regular-withdrawals"
    }
  }), _vm._v(" "), _c('Tool', {
    attrs: {
      "context": "systematicWithdrawals",
      "title": _vm._translate('panel.toolSystematicWithdrawals'),
      "tmp": "Systematic Withdrawals from an Investment",
      "icon": "systematic-withdrawals"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.context === 'snapshots') ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.snapshotsTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "panel__instruction"
  }, [_vm._v(_vm._s(_vm._translate('panel.snapshotInstructionIntro'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setCurrentSnapshotInstructions())
    }
  }), _vm._v(".")]), _vm._v(" "), _c('ul', {
    key: this.key,
    staticClass: "panel__snapshots-list"
  }, [_c('li', {
    staticClass: "panel__snapshots-item"
  }, [_c('div', {
    staticClass: "panel__snapshots-ctrl"
  }, [_c('button', {
    class: _vm.setSnapshotButtonClass('current'),
    on: {
      "click": function($event) {
        _vm.setCurrentSnapshot('current')
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('panel.useCurrentData')))])])]), _vm._v(" "), _vm._l((this.getSnapshots()), function(item, index) {
    return _c('li', {
      staticClass: "panel__snapshots-item"
    }, [_c('div', {
      staticClass: "panel__snapshots-ctrl"
    }, [_c('button', {
      class: _vm.setSnapshotButtonClass(index),
      on: {
        "click": function($event) {
          _vm.setCurrentSnapshot(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.getSnapshotDate(index)))]), _vm._v(" "), _c('button', {
      staticClass: "edit",
      on: {
        "click": function($event) {
          _vm.editSnapshotDate(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "icon": "pencil"
      }
    }), _c('span', [_vm._v(_vm._s(_vm._translate('ui.edit')))])], 1), _vm._v(" "), _c('button', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.deleteSnapshot(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._translate('ui.delete')))])]), _vm._v(" "), (_vm.isGPSData(index)) ? _c('span', {
      staticClass: "gps_fixed"
    }, [_c('Icon', {
      attrs: {
        "icon": "link"
      }
    })], 1) : _vm._e()]), _vm._v(" "), (_vm.snapshotedit == index) ? _c('DatePicker', {
      attrs: {
        "id": "changeSnapshot",
        "title": "Change Date",
        "field": "snapshot",
        "context": "snapshot",
        "snapshot": index
      },
      on: {
        "updateDate": _vm.finishUpdateSnapshotDate
      }
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button button--snapshot",
    on: {
      "click": _vm.takeSnapshot
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "camera"
    }
  }), _vm._v(_vm._s(_vm._translate('panel.takeSnapshot')))], 1)]) : _vm._e(), _vm._v(" "), (this.context === 'settings' && _vm.isCurrentTab('language')) ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.applicationLanguageTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "panel__instruction",
    domProps: {
      "innerHTML": _vm._s(_vm.setLanguageSwitcherText('detail'))
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button panel__button",
    domProps: {
      "innerHTML": _vm._s(_vm.setLanguageSwitcherText('button'))
    },
    on: {
      "click": function($event) {
        _vm.setAppLanguage()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (this.context === 'settings' && _vm.isCurrentTab('constants')) ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.constantsTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "currentYear",
      "label": _vm._translate('panel.constantCurrentYear'),
      "tmp": "Current Year",
      "field": "currentYear",
      "type": "text",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "maxOASPay",
      "label": _vm._translate('panel.constantMaximumOasPayout'),
      "tmp": "Maximum Monthly OAS Payout",
      "field": "maxOASPay",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "maxOASThresh",
      "label": _vm._translate('panel.constantMaximumOasIncomeThreshold'),
      "tmp": "Maximum OAS Income Threshold",
      "field": "maxOASThresh",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "maxCPPPay",
      "label": _vm._translate('panel.constantMaximumCppPayout'),
      "tmp": "Maxmium CPP Payout",
      "field": "maxCPPPay",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "maxCPPThresh",
      "label": _vm._translate('panel.constantMaximumCppIncomeThreshold'),
      "tmp": "Maximum CPP Income Threshold",
      "field": "maxCPPThresh",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "cppBenefit",
      "label": _vm._translate('panel.constantCppDeathBenefit'),
      "tmp": "CPP Death Benefit",
      "field": "cppBenefit",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "survivorPension",
      "label": _vm._translate('panel.constantSurvivorPension'),
      "tmp": "Survivor's Pension",
      "field": "survivorPension",
      "type": "currency",
      "setting": "true"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.constantLifSchedule'),
      "tmp": "LIF Schedule",
      "field": "lifSchedule",
      "totalby": "none",
      "proto": "lifSchedule",
      "setting": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.context === 'settings' && _vm.isCurrentTab('disaster')) ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.disasterTitle')))]), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.shockEvents'),
      "field": "shockEvents",
      "totalby": "none",
      "proto": "shockEvents",
      "setting": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.context === 'settings' && _vm.isCurrentTab('print')) ? _c('div', {
    staticClass: "panel__block"
  }, [_c('h2', {
    staticClass: "panel__heading"
  }, [_vm._v(_vm._s(_vm._translate('panel.printOptionsTitle')))]), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "printTitle",
      "label": _vm._translate('panel.defaultPrintTitle'),
      "field": "printTitle",
      "type": "text",
      "setting": "true"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "printTitle",
      "label": _vm._translate('panel.defaultPrintTitleFr'),
      "field": "printTitleFr",
      "type": "text",
      "setting": "true"
    }
  }), _vm._v(" "), _c('Repeater', {
    attrs: {
      "title": _vm._translate('panel.disclaimers'),
      "field": "disclaimers",
      "totalby": "none",
      "proto": "disclaimers",
      "setting": "true"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (this.sub === 'true') ? _c('div', {
    class: _vm.setExtendedClass
  }, [_c('div', {
    staticClass: "panel__frame"
  }, [_c(_vm.currentView, {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel__extend-control"
  }, [_c('div', {
    staticClass: "repeater-form__buttons"
  }, [_c('div', {
    staticClass: "repeater-form__buttons-left"
  }, [(this.context !== 'tools') ? _c('button', {
    staticClass: "button modal-default-button",
    on: {
      "click": _vm.closeSubpanel
    }
  }, [_vm._v(_vm._s(_vm._translate('ui.save')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button modal-default-button",
    on: {
      "click": _vm.cancelSubpanel
    }
  }, [_vm._v(_vm._s(_vm._translate('ui.cancel')))])]), _c('div', {
    staticClass: "repeater-form__buttons-right"
  }, [(_vm.isRepeater()) ? _c('button', {
    staticClass: "button modal-default-button",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v(_vm._s(_vm._translate('ui.add')))]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32003b10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel.vue
// module id = 314
// module chunks = 0